import Typography from '@mui/material/Typography';
import { FC, memo } from 'react';

import { RouteProps } from './type';
import { EXTERNAL_ROUTE_PROPS, isCommunicationRoute } from './utils';

type ExternalRouteProps = Omit<RouteProps, 'hash'>;

const ExternalRoute: FC<ExternalRouteProps> = ({ children, href, ...props }) => {
  const isCommRoute = isCommunicationRoute(href);

  return (
    <Typography
      {...props}
      component='a'
      href={href}
      rel={isCommRoute ? undefined : EXTERNAL_ROUTE_PROPS.rel}
      target={isCommRoute ? undefined : EXTERNAL_ROUTE_PROPS.target}
    >
      {children}
    </Typography>
  );
};

export default memo(ExternalRoute);
